import React, { useContext, useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Typography, Switch, Button, IconButton, Box, Tooltip } from '@mui/material';
import { DateField } from '@mui/x-date-pickers/DateField';
import { enGB } from 'date-fns/locale';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ThemeContext } from '../ThemeContext/ThemeContext';
import { AddCircleSharp, CloseOutlined } from '@mui/icons-material';
import FieldTypeSelector from '../FieldTypeSelector';

const DynamicField = ({ setOpenFieldManager, editable, field, updateField, ...props }) => {

  const { theme } = useContext(ThemeContext);
  const [newOption, setNewOption] = useState('');
  const [fieldOptions, setFieldOptions] = useState(field.options);
  const [fieldVisible, setFieldVisible] = useState(field.visible);
  const [newField, setNewField] = useState({ name: field.name, type: field.type, options: [], visible: field.visible });

  const handleToggleVisibility = async (checked) => {
    setNewField({ ...newField, visible: checked });
    setFieldVisible(checked);
  };
  const handleAddOption = () => {
    setFieldOptions([...fieldOptions, newOption]);
    setNewOption('');
  };

  const handleEditOption = (value, index) => {
    const updatedOptions = [...fieldOptions];
    updatedOptions[index] = value;
    setFieldOptions(updatedOptions);
  };

  const handleRemoveOption = (index) => {
    setFieldOptions(fieldOptions.filter((_, i) => i !== index));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      console.log(e.key)
      console.log(newField)
      updateField({ ...newField, id: field.id }); setOpenFieldManager(false);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    }

  }, [handleKeyPress])

  const SaveContent = () => {
    return (
      <Grid container justifyContent={'space-around'} sx={{ borderRadius: '0 0 8px 8px' }}>
        <Button onClick={() => setOpenFieldManager(false)} sx={{ color: theme.palette.error.main }}>Cancelar</Button>
        <Button sx={{ color: theme.palette.success.main }}
          onClick={() => { updateField({ ...newField, id: field.id }); setOpenFieldManager(false); }}>Salvar</Button>
      </Grid >
    )
  };

  switch (newField.type) {
    case 'text':
      return (
        <Grid container sx={{ padding: editable ? 2 : 0, bgcolor: theme.palette.background.paper, borderRadius: '8px' }}>
          <Grid sx={{ width: editable ? '50%' : '100%', padding: editable ? 1 : 0 }}>
            <InputLabel sx={{ marginBottom: 0.5 }}>
              {editable ? 'Editar nome do campo' : `Campo: ${field.name}`}
            </InputLabel>
            <TextField
              label={field.name}
              required={field.validation_rules?.required}
              inputProps={{ maxLength: field.validation_rules?.maxLength }}
              value={newField.name}
              onChange={(e) => setNewField({ ...newField, name: e.target.value })}
              onKeyDown={handleKeyPress}
              fullWidth
            />
          </Grid>
          {editable && (
            <Grid container direction="column" alignItems="center" justifyContent="center" item xs={6}>
              <Typography>Habilitar/Desabilitar campo</Typography>
              <Switch
                checked={fieldVisible}
                onChange={(e) => handleToggleVisibility(e.target.checked)}
              />
            </Grid>
          )}
          {editable &&
            <Grid container direction="column" justifyContent="center" item xs={12} sx={{  padding: editable ? 1 : 0}}>
              <Typography>Editar tipo do campo</Typography>
              <FieldTypeSelector
                value={newField.type}
                field={newField}
                setNewField={setNewField}
              />
            </Grid>
          }
          {editable && <SaveContent />}
        </Grid>
      );
    case 'select':
      // if (!Array.isArray(field.options) || field.options.length === 0) {
      //   return <div>Não foram definidas opções para o campo!</div>;
      // }
      return (
        <Box sx={{ padding: editable ? 2 : 0, borderRadius: '8px', bgcolor: theme.palette.background.paper }}>
          <Grid container alignItems="center">
            {editable ?
              <Grid item xs={12} container direction="row" alignItems="center" paddingLeft={0.5}>
                <Grid item xs={6}>
                  <InputLabel sx={{ marginBottom: 0.5 }}>Editar nome do campo</InputLabel>
                  <TextField
                    label={field.name}
                    type="text"
                    required={field.validation_rules?.required}
                    value={newField.name}
                    onChange={(e) => setNewField({ ...newField, name: e.target.value })}
                    sx={{ marginTop: 0.5 }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6} container justifyContent={'center'}>
                  <Typography sx={{ marginBottom: 0.5 }}>Habilitar/Desabilitar campo</Typography>
                  <Switch
                    checked={fieldVisible}
                    onChange={(e) => handleToggleVisibility(e.target.checked)}
                    sx={{
                      width: '59px',
                      height: '38px',
                      padding: '9px',
                      '& .MuiSwitch-switchBase.Mui-checked': {
                        color: theme.palette.switch.on, // Cor do thumb quando está checked
                        '&:hover': {
                          backgroundColor: theme.palette.switch.track, // Cor do fundo do thumb quando hover e checked
                        },
                      },
                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: theme.palette.switch.trackChecked, // Cor do track quando está checked
                      },
                      '& .MuiSwitch-switchBase': {
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.08)', // Cor do fundo do thumb quando hover e não checked
                        },
                      },
                      '& .MuiSwitch-track': {
                        backgroundColor: theme.palette.switch.track, // Cor do track quando não está checked
                      },
                    }}
                  />

                </Grid>
              </Grid>
              :
              <Grid item xs={12} sm={6}>
                <InputLabel sx={{ marginBottom: 0.5 }}>Campo: {newField.name}</InputLabel>
                <FormControl fullWidth>
                  <InputLabel>{newField.name}</InputLabel>
                  <Select label={newField.name} required={field.required}>
                    {fieldOptions.map((option, index) => (
                      <MenuItem key={index} value={option}>{option}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            }
            {editable && field.type === 'select' && (
              <>
                <Grid item xs={12} container direction={'column'} alignItems="center" marginTop={1} paddingLeft={0.5}>
                  <Grid item xs={6}>
                    <InputLabel>Configuraçãoes das opções</InputLabel>
                    <TextField
                      label="Adicionar opção"
                      value={newOption}
                      onChange={(e) => setNewOption(e.target.value)}
                      sx={{ marginTop: 0.5 }}
                      fullWidth
                    />
                  </Grid>
                  <Grid container item alignItems={'center'} justifyContent={'center'} xs={6}>
                    <Tooltip title='Adicionar opção' arrow placement='bottom' >
                      <IconButton onClick={handleAddOption}>
                        <AddCircleSharp />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
                <Grid item xs={12} paddingLeft={0.5} marginTop={0.5}>
                  <InputLabel>Opções</InputLabel>
                  {fieldOptions.map((option, index) => (
                    <Grid container alignItems="center" key={index} marginTop={1}>
                      <Grid item xs>
                        <TextField
                          fullWidth
                          value={option}
                          onChange={(e) => handleEditOption(e.target.value, index)}
                        />
                      </Grid>
                      <Grid item>
                        <Tooltip title='Excluir opção' arrow placement='top'>
                          <IconButton onClick={() => handleRemoveOption(index)}>
                            <CloseOutlined />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Grid>
          {editable &&
            <Grid container direction="column" justifyContent="center" item xs={12} sx={{  padding: editable ? 1 : 0}}>
              <Typography>Editar tipo do campo</Typography>
              <FieldTypeSelector
                value={newField.type}
                field={newField}
                setNewField={setNewField}
              />
            </Grid>
          }
          {editable && <SaveContent />}
        </Box>
      );
    case 'date':
      return (
        <Grid container sx={{ borderRadius: '8px' }}>
          <TextField
            label={field.name}
            type="date"
            required={field.validation_rules?.required}
            onChange={(e) => setNewField({ ...newField, name: e.target.value })}
          />
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
            <DateField
              label={field.name}
              renderInput={(params) => <TextField {...params} />}
              required={field.validation_rules?.required}
            />
          </LocalizationProvider>
          {editable &&
            <Grid container direction={'column'} alignItems={'center'} item
              sx={{ borderRadius: '0 8px 8px 0', alignContent: 'center', width: editable ? '50%' : '100%' }} >
              <Typography>Habilitar/Desabilitar campo</Typography>
              <Switch
                checked={fieldVisible}
                onChange={(e) => handleToggleVisibility(e.target.checked)}
              />
            </Grid>
          }
          {editable &&
            <Grid container direction="column" justifyContent="center" item xs={12} sx={{  padding: editable ? 1 : 0}}>
              <Typography>Editar tipo do campo</Typography>
              <FieldTypeSelector
                value={newField.type}
                field={newField}
                setNewField={setNewField}
              />
            </Grid>
          }
          {editable && <SaveContent />}
        </Grid>
      );
    case 'number':
      return (
        <Grid container sx={{ padding: editable ? 2 : 0, bgcolor: theme.palette.background.paper, borderRadius: '8px' }}>
          {editable ? (
            <>
              <Grid item xs={6} sx={{ padding: 1 }}>
                <InputLabel sx={{ marginBottom: 0.5 }}>Editar nome do campo</InputLabel>
                <TextField
                  label={field.name}
                  type="text"
                  required={field.validation_rules?.required}
                  inputProps={{ min: field.validation_rules?.min, max: field.validation_rules?.max }}
                  value={newField.name}
                  onChange={(e) => setNewField({ ...newField, name: e.target.value })}
                  onKeyDown={handleKeyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} container direction="column" alignItems="center" justifyContent="center">
                <Typography>Habilitar/Desabilitar campo</Typography>
                <Switch
                  checked={fieldVisible}
                  onChange={(e) => handleToggleVisibility(e.target.checked)}
                />
              </Grid>
            </>
          ) : (
            <Grid item xs={12}>
              <InputLabel sx={{ marginBottom: 0.5 }}>Campo: {field.name}</InputLabel>
              <TextField
                label={field.name}
                type="number"
                required={field.validation_rules?.required}
                inputProps={{ min: field.validation_rules?.min, max: field.validation_rules?.max }}
                value={newField.name}
                onChange={(e) => setNewField({ ...newField, name: e.target.value })}
                fullWidth
              />
            </Grid>
          )}
          {editable &&
            <Grid container direction="column" justifyContent="center" item xs={12} sx={{  padding: editable ? 1 : 0}}>
              <Typography>Editar tipo do campo</Typography>
              <FieldTypeSelector
                value={newField.type}
                field={newField}
                setNewField={setNewField}
              />
            </Grid>
          }
          {editable && <SaveContent />}
        </Grid>
      );
    default:
      return <div>Unknown Field Type</div>;
  }
};

export default DynamicField;
